import { Box, List, ListItem, ListIcon, Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconCheckCircle } from 'assets/icons';
import { routePaths } from 'global/routePaths';
import { useFetchOnBoardingStep } from 'hooks/common/useFetchOnBoardingStep';
import toaster from 'utils/toaster';

const OnBoardingStep = () => {
  const { t } = useTranslation(['common', 'components']);
  const navigate = useNavigate();

  const { data, isLoading } = useFetchOnBoardingStep();

  if (data?.payload?.percent_completed === 100 || isLoading) return null;

  return (
    <Box bg="primary.500" height="50px" overflowX="auto">
      <List display="flex" textAlign="center" color="white" width="100%" height="100%" fontWeight="semibold">
        {data?.payload?.percent_completed ? (
          <ListItem as="li" flex="1 0 170px" height="100%" display="flex" alignItems="center" justifyContent="center">
            <Badge bg="primary.800" color="white" fontSize="sm" textTransform="capitalize" py="1.5" px="3">
              {data?.payload?.percent_completed}% {t('common:complete')}
            </Badge>
          </ListItem>
        ) : null}

        <ListItem as="li" flex="1 0 170px" height="100%" display="flex" alignItems="center" justifyContent="center">
          <ListIcon as={IconCheckCircle} color="green.500" boxSize="4" />
          {t('common:signUp')}
        </ListItem>
        <ListItem
          as="li"
          flex="1 0 170px"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={() => navigate(routePaths.employees.base.route)}
        >
          {data?.payload?.setup_users ? <ListIcon as={IconCheckCircle} color="green.500" boxSize="4" /> : null}
          {t('common:addPeople')}
        </ListItem>
        <ListItem
          as="li"
          flex="1 0 170px"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={() => navigate(routePaths.jobsAndTasks.base.route)}
        >
          {data?.payload?.setup_jobs ? <ListIcon as={IconCheckCircle} color="green.500" boxSize="4" /> : null}
          {t('common:createJobs')}
        </ListItem>
        <ListItem
          as="li"
          flex="1 0 170px"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          onClick={() => {
            toaster.info({ description: t('common:turnOnTrackMileageOnAUserAndOnAJob') });
          }}
        >
          {data?.payload?.setup_mileage ? <ListIcon as={IconCheckCircle} color="green.500" boxSize="4" /> : null}
          {t('common:setupMileage')}
        </ListItem>
      </List>
    </Box>
  );
};

export default OnBoardingStep;
